import VolunteerActivityQ from '@/queries/VolunteerActivityQ'
import { SQL, type SQLFragment } from '@/client/query'
import { VOLUNTEER_ACTIVITY_TO_LABEL } from '@/client/services/volunteerActivity'

export function getActivityTypeFilters(): Record<string, SQLFragment<unknown>> {
  const typeFilters: Record<string, SQLFragment<unknown>> = {
    All: SQL`TRUE`,
  }
  Object.entries(VOLUNTEER_ACTIVITY_TO_LABEL)
    // Sort alphabetically by label
    .sort((a, b) => (a[1] < b[1] ? -1 : 1))
    .forEach(([activity, label]) => {
      typeFilters[label] = SQL`${VolunteerActivityQ.type} = ${activity}`
    })
  return typeFilters
}
